export const filtersFeedInitial = {
  favorite: false,
  id: null,
  medium: [],
  pageConfigIds: [],
  scheduledFor: {
    gte: "",
    lte: "",
  },
  socialPageGroupIds: [],
  sortByDescending: false,
  status: [],
  type: [],
};
